import acYear from '@/api/academic-year'
import { baseState, baseMutations } from '@/store/mixins'
import { join } from 'lodash'

export const state = {
  ...baseState,
  edit_data: {},
  acStatus: [],
  ac_status_id: [1],
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  RECEIVE_AC_STATUS(state, data) {
    state.acStatus = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_STATUS_ID(state, data) {
    state.ac_status_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        filter: {
          ac_status_id: context.state.ac_status_id
            ? join(context.state.ac_status_id, ',')
            : undefined
        }
      },
      attrubutes
    )
    return acYear.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return acYear.store(data)
  },
  update(context, data) {
    return acYear.update(data)
  },
  destroy(context, id) {
    return acYear.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await acYear.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.acStatus.length > 0) {
      let response = await acYear.getStatus()
      context.commit('RECEIVE_AC_STATUS', response)
    }
  },

  getStatus(context, option) {
    return acYear.getStatus(option)
  }
}
